import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { Constant } from '../..//shared/constant';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, map,  } from 'rxjs/operators';
import { Subject, throwError } from 'rxjs';
import { LaunchParams } from '../..//shared/Models/LaunchParams';
import { SaveStatusParam } from '../..//shared/Models/SaveStautusParams';
import { Location } from "@angular/common";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })
};

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  APIUrl = '';
  style: object = {};
  constructor(private cookieService: CookieService, private http : HttpClient, private location: Location) { }
   SaveStatus(payload: SaveStatusParam) {
    this.APIUrl = `${Constant.BaseAPIURL}SaveStatus`;
    return this.http.post(this.APIUrl, payload, httpOptions).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
   }

   LTILaunch(launchparams: LaunchParams) {
    this.APIUrl = Constant.BaseAPIURL + 'LTILaunch';
    return this.http.post(this.APIUrl, launchparams, httpOptions).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

   private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    }
    else {
      // The backend returned an unsuccessful response code. The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError(error);
  }

  GetEHRLearningUnitDetails(LearningUnitID: number, ContentID: string) {
    this.APIUrl = Constant.BaseAPIURL + 'GetEHRLearningUnitDetails/' + LearningUnitID + '/' + ContentID;
    return this.http.get(this.APIUrl, httpOptions).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public SessionExpiry = new Subject<any>();
  SessionExpiryObservable = this.SessionExpiry.asObservable();
  startInactivityTimer(InactivityTimer: boolean) {   
    this.SessionExpiry.next(InactivityTimer);
  }
}
